var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('ExperimentalInvoicesApiSearchPage',{staticClass:"page-size",staticStyle:{"border":"1px solid var(--primaryColor)"},attrs:{"title":"Próbaszámlák válogatása","inStatement":false}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }